import { CollectionContent, CollectionItem, ItemAvatar } from './styles';
import LocalIcon, { LocalIconTypes } from '../../../../ui/LocalIcon';
import Input from '../../../../components/Input';
import { SpaceBetween } from '../../../../utils/style/extendable';
import Button from '../../../../components/Button';
import i18n from '../../../../i18n';
import React, { useState } from 'react';
import { IProviderItemViewWithData } from '../../../../store/providers/providerTypes';
import cloneDeep from 'lodash/cloneDeep';
import { appDispatch } from '../../../../store/store';
import { updateItem } from '../../../../store/providers/providerSlice';

interface IChangeExternalLinkProps {
  item: IProviderItemViewWithData;
  iconType: LocalIconTypes;
  iconColor: string;
  afterSave: () => void;
}

const ChangeExternalLink: React.FC<IChangeExternalLinkProps> = ({
  item,
  iconColor,
  iconType,
  afterSave,
}) => {
  const [updatedUrl, setUpdatedUrl] = useState(() => item.data.url);
  const [isLoading, setIsLoading] = useState(false);

  const onSubmitForm = (event: any) => {
    event.preventDefault();
    setIsLoading(true);
    const updatedItem = cloneDeep(item.data);
    updatedItem.url = updatedUrl;

    appDispatch(updateItem({ item: updatedItem })).then(() => {
      setIsLoading(false);
      afterSave();
    });
  };

  return (
    <form onSubmit={onSubmitForm}>
      <CollectionItem key={item.data.id}>
        <CollectionContent>
          <ItemAvatar>
            <LocalIcon iconName={iconType} color={iconColor} />
          </ItemAvatar>
          <div className="full-width valign">
            <Input
              id={`${item.data.url}`}
              label="URL"
              type="text"
              onChange={(event) => {
                setUpdatedUrl(event.target.value);
              }}
              value={updatedUrl}
            />
            <SpaceBetween>
              <Button type="submit" color="green" loading={isLoading}>
                {i18n.t('confirm', { ns: 'documentManager' }) as string}
              </Button>
              <Button onClick={afterSave} color="red">
                {i18n.t('cancel', { ns: 'documentManager' }) as string}
              </Button>
            </SpaceBetween>
          </div>
        </CollectionContent>
      </CollectionItem>
    </form>
  );
};

export default ChangeExternalLink;
